import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";
import { encodeData } from "~/utils/utils.jsx";

export const useTimeRecordsTotalInfo = (parentType, parentId, queryData = {}, config) => {
  const query = encodeData(queryData);
  return useQuery({
    ...config,
    queryKey: ["time-records-user-total", parentType, parentId, query],
    queryFn: () =>
      fetch({
        url: `${Angie.api_url}/time-records/${parentType.toLowerCase()}/${parentId}/info?${query}`,
      }),
  });
};
